import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["stepperType", "size", "disabled"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { clsx } from 'clsx';
import styles from './styles.module.css';
import { IconActionMinus16, IconActionPlus16 } from '@cian/ui-kit-design-tokens/icons';
import { jsx as _jsx } from "react/jsx-runtime";
export const StepperButton = _ref => {
  let {
      stepperType,
      size = 'M',
      disabled
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const Icon = stepperType === 'decrement' ? IconActionMinus16 : IconActionPlus16;
  return /*#__PURE__*/_jsx("button", _objectSpread(_objectSpread({}, rest), {}, {
    disabled: disabled,
    role: "button",
    className: clsx(styles['stepper-button'], styles["stepper-button--".concat(size)], stepperType === 'decrement' && styles['stepper-button--left'], stepperType === 'increment' && styles['stepper-button--right']),
    children: /*#__PURE__*/_jsx("div", {
      className: styles['icon-wrapper'],
      children: /*#__PURE__*/_jsx(Icon, {
        color: "current_color"
      })
    })
  }));
};